import { createFileRoute, Outlet, redirect, isRedirect } from "@tanstack/react-router";
import { Layout } from "@/components/layout";
import { authApi } from "@/api/client";

export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ location }) => {
    try {
      const user = await authApi.me();
      if (user.must_change_password && location.pathname !== "/change-password") {
        throw redirect({ to: "/change-password" });
      }
      return { user };
    } catch (error) {
      if (isRedirect(error)) {
        throw error;
      }
      throw redirect({
        to: "/login",
        search: { redirect: location.href },
      });
    }
  },
  component: () => (
    <Layout>
      <Outlet />
    </Layout>
  ),
});
